import { render, staticRenderFns } from "./OrganizationAnalytics.vue?vue&type=template&id=1493d56d"
import script from "./OrganizationAnalytics.vue?vue&type=script&lang=js"
export * from "./OrganizationAnalytics.vue?vue&type=script&lang=js"
import style0 from "./OrganizationAnalytics.vue?vue&type=style&index=0&id=1493d56d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports